import { Notify } from 'quasar'
import axios from 'axios'
import { getErrorCodeFromResponse } from 'src/utils/error'

export default ({ app, router, store, Vue }) => {
  const decoder = new TextDecoder()

  let requestingTokenLock = null
  let waitingRequests = []

  axios.interceptors.response.use(response => response, error => {
    if (getErrorCodeFromResponse(error) === 'RECENT_PASSWORD_CHANGE') {
      store.dispatch('logout')
      router.push('/login')
      Notify.create({ message: app.i18n.t('RECENT_PASSWORD_CHANGE'), type: 'negative' })

      return Promise.reject(error)
    }

    if (error.response.status === 401 && error.response.data.constructor === ArrayBuffer) {
      try {
        error.response.data = JSON.parse(decoder.decode(error.response.data))
      } catch (e) {
        return Promise.reject(error)
      }
    }

    if (error.response.status !== 401 || getErrorCodeFromResponse(error) !== 'TOKEN_EXPIRED' || !error.config) {
      return Promise.reject(error)
    }

    let retry = config => {
      let request = config.request
      // Because error.config still has the old token we have to overwrite it manually
      request.headers.Authorization = `Bearer ${store.getters.token}`
      axios(request).then(config.callback)
    }

    return new Promise((resolve, reject) => {
      waitingRequests.push({
        request: error.config,
        callback: resolve
      })

      if (requestingTokenLock) return
      requestingTokenLock = true

      return store.dispatch('refreshToken')
        .then(() => {
          waitingRequests.forEach(retry)
          requestingTokenLock = null
        })
        .catch(error => {
          requestingTokenLock = null
          waitingRequests = []

          store.dispatch('logout')
          router.push('/login')
          Notify.create({ message: app.i18n.t('TOKEN_EXPIRED'), type: 'negative' })

          reject(error)
        })
    })
  })
}
